var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 淘客由用户在 app 个人中心自行提交申请，平台审核。审核结果"
            ),
            _c("b", [_vm._v("不发通知")]),
            _vm._v(
              "，用户自己回页面看， 所以驳回理由要写清楚能照着改的内容。驳回后用户可以重新提交，不限次数。 身份证号一律脱敏显示，后台拿不到明文。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      on: {
                        change: function ($event) {
                          return _vm.load(1)
                        },
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "待审核", value: 0 } }),
                      _c("el-option", { attrs: { label: "已通过", value: 1 } }),
                      _c("el-option", { attrs: { label: "已驳回", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名/手机号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "keyword", $$v)
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "申请人", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.realName || "—"))]),
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v("uid " + _vm._s(row.uid)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", width: "130" },
              }),
              _c("el-table-column", {
                attrs: { label: "当前绑定上级", "min-width": "230" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.boundUpline && row.boundUpline.status === "BOUND"
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(row.boundUpline.name || "用户") +
                                    "（UID " +
                                    _vm._s(row.boundUpline.uid) +
                                    "）"
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "推广码：" +
                                    _vm._s(row.boundUpline.promoCode || "暂无")
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "绑定时间：" +
                                    _vm._s(row.boundUpline.bindTime || "未记录")
                                ),
                              ]),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  !row.boundUpline
                                    ? "绑定信息暂不可用"
                                    : row.boundUpline.status === "PENDING"
                                    ? "尚未确认上级"
                                    : row.boundUpline.status === "INACTIVE"
                                    ? "关系已解除"
                                    : "未绑定上级"
                                )
                              ),
                            ]),
                        row.boundUpline &&
                        row.boundUpline.status === "BOUND" &&
                        row.inviterUid > 0 &&
                        row.inviterUid !== row.boundUpline.uid
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v("与申请推荐人不同，保留原绑定关系"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "idCardNo",
                  label: "身份证号",
                  "min-width": "170",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "申请填写推荐码", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.inviterCode
                          ? _c("span", [_vm._v(_vm._s(row.inviterCode))])
                          : _c("span", { staticClass: "sub-line" }, [
                              _vm._v("未填"),
                            ]),
                        row.inviterUid > 0
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v(
                                "申请推荐人 UID " + _vm._s(row.inviterUid)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusType(row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.status)))]
                        ),
                        row.quickPass === 1
                          ? _c(
                              "el-tag",
                              {
                                staticClass: "quick-tag",
                                attrs: { size: "mini", type: "warning" },
                              },
                              [_vm._v("一键通过")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审核信息", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.auditTime
                          ? _c("div", [_vm._v(_vm._s(row.auditTime))])
                          : _vm._e(),
                        row.auditUid > 0
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v("操作人 " + _vm._s(row.auditUid)),
                            ])
                          : _vm._e(),
                        row.auditRemark
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v(_vm._s(row.auditRemark)),
                            ])
                          : _vm._e(),
                        !row.auditTime
                          ? _c("span", { staticClass: "sub-line" }, [
                              _vm._v("—"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "提交时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "190", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.approve(row)
                                    },
                                  },
                                },
                                [_vm._v("通过")]
                              ),
                              _vm.canQuickPass
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.quickApprove(row)
                                        },
                                      },
                                    },
                                    [_vm._v("一键通过")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  staticClass: "danger-text",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReject(row)
                                    },
                                  },
                                },
                                [_vm._v("驳回")]
                              ),
                            ]
                          : _c("span", { staticClass: "sub-line" }, [
                              _vm._v("已处理"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: { "size-change": _vm.onSize, "current-change": _vm.load },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "驳回申请",
            visible: _vm.rejectVisible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "驳回理由", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                      placeholder:
                        "写清楚哪里不合格、怎么改，用户看到的就是这段话",
                    },
                    model: {
                      value: _vm.rejectRemark,
                      callback: function ($$v) {
                        _vm.rejectRemark = $$v
                      },
                      expression: "rejectRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.rejectVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitReject },
                },
                [_vm._v("确定驳回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }